import { render, staticRenderFns } from "./NavigationDrawerItems.vue?vue&type=template&id=a1ca8da4&scoped=true&"
import script from "./NavigationDrawerItems.vue?vue&type=script&lang=js&"
export * from "./NavigationDrawerItems.vue?vue&type=script&lang=js&"
import style0 from "./NavigationDrawerItems.vue?vue&type=style&index=0&id=a1ca8da4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ca8da4",
  null
  
)

export default component.exports